var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "elclickoutside",
          rawName: "v-elclickoutside",
          value: _vm.handleClose,
          expression: "handleClose",
        },
      ],
      ref: "reference",
      staticClass: "wk-dep-select xh-form-border",
      class: [
        _vm.disabled ? "is_disabled" : "is_valid",
        { is_focus: _vm.visible },
      ],
      style: { height: `${_vm.height}px` },
      attrs: { wrap: "wrap" },
      on: { click: _vm.containerClick },
    },
    [
      _c(
        "div",
        { ref: "tags", staticClass: "el-select__tags" },
        _vm._l(_vm.showSelects, function (item, index) {
          return _c(
            "span",
            { key: index, staticClass: "user-item text-one-line" },
            [
              _vm._v(_vm._s(item.name) + "\n      "),
              _c("i", {
                staticClass: "delete-icon el-icon-close",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.deleteDep(index)
                  },
                },
              }),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.selects.length > _vm.max
        ? _c("i", { staticClass: "el-icon-more" })
        : _vm._e(),
      _vm._v(" "),
      _c("i", { class: ["el-icon-arrow-up", { "is-reverse": _vm.visible }] }),
      _vm._v(" "),
      _vm.selects.length == 0
        ? _c("div", { staticClass: "user-placeholder text-one-line" }, [
            _vm._v(_vm._s(_vm.placeholder)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "transition",
        {
          attrs: { name: "el-zoom-in-top" },
          on: {
            "before-enter": _vm.handleMenuEnter,
            "after-leave": _vm.doDestroy,
          },
        },
        [
          _c(
            "wk-select-dropdown",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.visible && !_vm.disabled,
                  expression: "visible && !disabled",
                },
              ],
              ref: "popper",
              attrs: { "append-to-body": _vm.popperAppendToBody },
            },
            [
              _c(
                "el-scrollbar",
                { ref: "scrollbar", attrs: { tag: "div" } },
                [
                  _c("wk-dep", {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading",
                      },
                    ],
                    attrs: {
                      options: _vm.optionsList,
                      props: _vm.props,
                      radio: _vm.radio,
                      disabled: _vm.disabled,
                      max: _vm.limit,
                    },
                    on: {
                      change: _vm.wkDepChange,
                      close: function ($event) {
                        _vm.visible = false
                      },
                    },
                    model: {
                      value: _vm.dataValue,
                      callback: function ($$v) {
                        _vm.dataValue = $$v
                      },
                      expression: "dataValue",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }